import { useNavigate } from "react-router-dom";
import AboutMainSection from "./AboutMainSection";
import CallToAction from "./CallToAction";
import WhyChooseUs from "./WhyChooseUs";
// import Associates from "./Associates";

const AboutPage = () => {
  const navigate = useNavigate();

  return (
    <>
      <div className="other-pages-main-section about-page-fin">
        <h2 className="other-pages-title">About Us</h2>
        <p>
          <span onClick={() => navigate("/")} style={{ cursor: "pointer" }}>
            Home
          </span>{" "}
          /
          <span
            onClick={() => navigate("/about-KRS-FinSolutions")}
            style={{ cursor: "pointer" }}
          >
            About us
          </span>
        </p>
      </div>
      {/* <Associates /> */}
      <div className="about-text-section-fin">
        <h1>Our Foundation</h1>
        <p>
          <strong style={{ fontSize: "1.6rem" }}>Our Mission:</strong>
          To empower enterprises by building a foundation of impeccable
          financial hygiene and strategic clarity. We are dedicated to
          transforming complex regulatory landscapes into competitive
          advantages, ensuring our partners achieve sustainable growth through
          precision, integrity, and proactive advisory.
        </p>
        <p>
          <strong style={{ fontSize: "1.6rem" }}>Our Vision:</strong>
          To be the most trusted strategic finance partner for growing Indian
          enterprises, recognized for bridging the gap between traditional
          compliance and modern boardroom strategy. We aim to redefine the role
          of financial consultants by becoming the catalyst for
          institutional-grade excellence in every business we touch.
        </p>
        <div className="core-values-section">
          <strong className="section-heading" style={{ fontSize: "1.6rem" }}>Our Core Values:</strong>

          <ul className="core-values-list">
            <li>
              <span className="core-title">Integrity First:</span>
              <p className="core-desc">
                Transparency isn't just a service; it's our operating system.
              </p>
            </li>

            <li>
              <span className="core-title">Proactive Partnership:</span>
              <p className="core-desc">
                We don't just solve problems; we identify them before they
                arise.
              </p>
            </li>

            <li>
              <span className="core-title">Agile Innovation:</span>
              <p className="core-desc">
                Combining deep-rooted technical expertise with modern digital
                tools.
              </p>
            </li>

            <li>
              <span className="core-title">Growth Mindset:</span>
              <p className="core-desc">
                Our success is measured solely by the scale and stability of our
                clients.
              </p>
            </li>
          </ul>
        </div>

        <div style={{ marginBottom: "1rem" }}>
          <strong style={{ fontSize: "1.6rem" }}>About KRS FinSolutions</strong>
          <p>
            Precision in Audit • Excellence in Advisory • Growth in Partnership
          </p>

          <p>
            Incorporated in 2021, KRS FinSolutions was founded on the principle
            that financial clarity is the ultimate catalyst for business growth.
            In an era of complex regulations and shifting market dynamics, we
            serve as a strategic anchor for enterprises, providing the technical
            precision of a traditional audit firm with the forward-thinking
            agility of a modern consultancy.
          </p>

          <p>
            We don’t just 'crunch numbers'—we build the financial hygiene
            necessary for valuation, scalability, and long-term investor
            confidence.
          </p>
        </div>
        <div style={{ marginBottom: "1rem" }}>
          <strong style={{ fontSize: "1.6rem" }}>Our Core Service Verticals</strong>
          <ul className="service-verticals-list">
            <li>
              <span className="service-title">Audit & Assurance:</span>
              <p className="service-desc">
                Statutory, Internal, and Tax Audits focused on transparency and
                risk mitigation.
              </p>
            </li>

            <li>
              <span className="service-title">
                Financial Hygiene & Managed Accounting:
              </span>
              <p className="service-desc">
                Virtual finance back-office, cloud bookkeeping, and catch-up
                accounting.
              </p>
            </li>

            <li>
              <span className="service-title">
                Indian Tax Advisory (Direct & Indirect):
              </span>
              <p className="service-desc">
                GST, Income Tax, ITC optimization, tax planning, and litigation
                support.
              </p>
            </li>

            <li>
              <span className="service-title">
                Capital & Lending Solutions:
              </span>
              <p className="service-desc">
                Debt syndication, working capital, and credit solutions.
              </p>
            </li>

            <li>
              <span className="service-title">
                Corporate Advisory & Virtual CFO:
              </span>
              <p className="service-desc">
                Budgeting, M&A support, ERP and finance transformation.
              </p>
            </li>

            <li>
              <span className="service-title">
                Registrations & Certifications:
              </span>
              <p className="service-desc">
                GST, MSME (ZED), FSSAI, ISO, and Pollution Control Board
                compliances.
              </p>
            </li>
          </ul>
        </div>
        <div style={{ marginBottom: "1rem" }}>
          <strong style={{ fontSize: "1.6rem" }}>The KRS Advantage</strong>
          <ul className="krs-advantage-list">
            <li>
              <span className="advantage-title">Partner-Led Attention:</span>
              <p className="advantage-desc">
                Senior partners are directly involved in every engagement.
              </p>
            </li>

            <li>
              <span className="advantage-title">Operational Agility:</span>
              <p className="advantage-desc">
                Faster turnaround with uncompromised quality.
              </p>
            </li>

            <li>
              <span className="advantage-title">Niche Industry Expertise:</span>
              <p className="advantage-desc">
                Agri, Healthcare, IT, Manufacturing, and E-commerce.
              </p>
            </li>
          </ul>
        </div>
      </div>

      <CallToAction />
    </>
  );
};

export default AboutPage;
